'use client';

import { useCheckout } from '../checkout-context';

export default function SuccessStep() {
  const { selectedPlan, successUrl } = useCheckout();

  if (!selectedPlan) return null;

  return (
    <div className="pt-8 relative ">
      <div
        className="absolute -top-10 opacity-65"
        style={{
          backgroundImage: 'url(/images/confetti@2x.png)',
          width: '100%',
          height: '365px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          backgroundSize: 'contain',
        }}
      ></div>
      {/* <div className="text-4xl mb-4">🎉</div> */}
      <h2 className="text-2xl font-bold mb-2 font-merriweather">
        Welcome to {selectedPlan.displayName}!
      </h2>
      <p className="text-slate-600 mb-6">
        You&apos;ve now unlocked all the amazing features created for dedicated journalers, just
        like you!
      </p>

      {(selectedPlan.tier === 'pro' || selectedPlan.tier === 'promonthly') && (
        <p className="text-slate-600 mb-6">You get everything in Basic, plus:</p>
      )}

      {(selectedPlan.tier === 'proplus' ||
        selectedPlan.tier === 'proplusmonthly' ||
        selectedPlan.tier === 'propluslifetime') && (
        <p className="text-slate-600 mb-6">You get all the benefits of Penzu Pro, plus:</p>
      )}

      {/* Feature highlights */}
      <ul className="text-left max-w-sm mx-auto mb-16 space-y-2">
        {selectedPlan.features.slice(0, 5).map((feature, index) => (
          <li key={index} className="flex items-center text-slate-600">
            <svg
              className="w-4 h-4 text-emerald-500 mr-2 shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            {feature}
          </li>
        ))}
      </ul>

      <a
        href={successUrl}
        className="btn-lg w-full text-center bg-blue-500 text-white hover:bg-blue-700 inline-block"
      >
        Go to your Penzu
      </a>
    </div>
  );
}
